import React, {useContext, useState} from 'react';
import styles from './admin-layout.module.scss';
import * as Tabs from '@radix-ui/react-tabs';
import {MaintenanceContext} from './contexts';
import MaintenanceCreateForm from './create-form';
import classNames from 'classnames';
import {useIntl} from 'react-intl';

interface MaintenceAdminLayoutProps {
  children: [React.ReactElement, React.ReactElement, React.ReactElement, React.ReactElement];
}

const MaintenanceClientLayout = ({children}: MaintenceAdminLayoutProps) => {
  const [activeTab, setActiveTab] = useState('registeredTab');
  const state = useContext(MaintenanceContext);
  const intl = useIntl();

  return (
    <div>
      {(() => {
        if (state.activeView === 'create') {
          return (
            <MaintenanceCreateForm />
          );
        }

        return (
          <div className={styles.tabsWrapper}>
            <Tabs.Root defaultValue='registeredTab' className={styles.tabs} onValueChange={(activeTab) => {
              setActiveTab(activeTab);
            }}>
              <Tabs.List className={styles.tabList}>
                  <Tabs.Trigger value="registeredTab" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceRegisteredTabTitle'})}
                  </Tabs.Trigger>
                  <Tabs.Trigger value="upcomingTab" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceUpcomingTabTitle'})}
                  </Tabs.Trigger>
                  <Tabs.Trigger value="ongoingTab" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceOngoingTabTitle'})}
                  </Tabs.Trigger>
                  <Tabs.Trigger value="completed" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceCompletedTabTitle'})}
                  </Tabs.Trigger>
              </Tabs.List>

              <Tabs.Content value="registeredTab" className={classNames(styles.tabContent, activeTab === 'registeredTab' && styles.noTabContentTopLeftBorderRadius)}>
                {children[0]}
              </Tabs.Content>

              <Tabs.Content value="upcomingTab" className={styles.tabContent}>
                {children[1]}
              </Tabs.Content>

              <Tabs.Content value="ongoingTab" className={styles.tabContent}>
                {children[2]}
              </Tabs.Content>

              <Tabs.Content value="completed" className={styles.tabContent}>
                {children[3]}
              </Tabs.Content>
            </Tabs.Root>
          </div>
        );
      })()}
    </div>

  );
};

export default MaintenanceClientLayout;
